import type { StationKey } from './schemas/station.js';

/**
 * What a routing step depends on when it does not say so itself: the step immediately
 * before it in the array, or nothing for the first step. Plain sequential routings
 * never need to set `dependsOn` at all — this is what makes that so.
 *
 * Shared by the scheduling engine (`server/src/domain/scheduler.ts`) and the template
 * editor, so "what happens if I leave this blank" answers the same way in both places.
 */
export function defaultDependsOn(
  routing: { stationKey: StationKey }[],
  index: number,
): StationKey[] {
  return index > 0 ? [routing[index - 1]!.stationKey] : [];
}
